export const pageName = {
  ACCEPT: 'Accept-And-Proceed',
  // PERSONAL: "Your-Details-Personal-Information",
  GETTING_STARTED: 'getting-started',
  CONTACT: 'Your-Details-Contact-Information',
  COVER: 'Select-Cover',
  QUOTE: 'Quote-Summary',
  SAVE_AND_EMAIL: 'Save-And-Email', //* New
  ABOUT_YOU_INFORMATION: 'About-You-Information', //* New
  ABOUT_YOU_DECLARATIONS: 'About-You-Declarations', //* New
  ABOUT_YOU_DISCLOSURE: 'About-You-Duty-Of-Disclosure',
  ABOUT_YOU_QUESTIONS: 'About-You-Questions',
  REVIEW_APPLICATION: 'review-application',
  PP_CONTACT: 'Payment-Contact-Details', //Shared
  PP_ONLINE_PAYMENT: 'Online-Payment-Details',
  PP_ONLINE_POLICY_OUTCOME: 'Online-Policy-Outcome',
  PP_CONFIRMATION: 'Policy-confirmation',
  CC_OPENING_SCRIPT: 'Opening-Script',
  PP_CC_PAYMENT: 'CC-Payment-Details',
  PP_CC_POLICY_OUTCOME: 'CC-Policy-Outcome',
  PP_POLICY_OUTCOME_DECLINE: 'Policy-Outcome-Decline',
  PP_CC_UPGRADE_SAVE_CONFIRMATION: 'CC-Upgrade-Save-Confirmation',
  PP_POLICY_PURCHASE_CONFIRMATION: 'Policy-Purchase-Confirmation',
  INFO_AND_DUTY: 'Information-and-Duty',
  RETRIEVE_QUOTE_LOADING: 'Retrieve-Quote-Loading',
  RETRIEVE_QUOTE_DECLINE: 'Retrieve-Quote-Decline',
  RETRIEVE_QUOTE_EXPIRED: 'Retrieve-Quote-Expired',
  RETRIEVE_QUOTE_REFERRED_UW: 'Retrieve-Quote-Referred-UW',
  RETRIEVE_QUOTE_BOUND: 'Retrieve-Quote-Bound',
  CC_PROCESSING_LANDING_PAGE: 'Processing-Landing-Page',
  CC_RETRIEVE_QUOTE_PAGE: 'Retrieve-Quote-Page',
  APPLICATION_ALREADY_DECLINED: 'Application-Already-Declined',
};

export const isQuotePages = (currentPageName) =>
  [
    pageName.ACCEPT,
    pageName.GETTING_STARTED,
    pageName.CONTACT,
    pageName.COVER,
    pageName.QUOTE,
    pageName.SAVE_AND_EMAIL,
    pageName.ABOUT_YOU_INFORMATION,
    pageName.ABOUT_YOU_DECLARATIONS,
    pageName.CC_OPENING_SCRIPT,
  ].indexOf(currentPageName) != -1;

export const isShowFloatingCardPages = (currentPageName) =>
  [
    // pageName.GETTING_STARTED,
    pageName.COVER,
    pageName.QUOTE,
    pageName.PP_ONLINE_POLICY_OUTCOME,
    pageName.PP_CC_POLICY_OUTCOME,
    pageName.PP_CC_PAYMENT,
    pageName.PP_ONLINE_PAYMENT,
    pageName.PP_CONFIRMATION,
  ].indexOf(currentPageName) != -1;
